import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';
import { ICursorElements, IState } from '@/store/types/search.types';
import { ITransferP2P, ISearchWalletP2P } from '@/store/models/p2p.model';
import { IWallet } from '@/features/wallets/store/models/wallet.model';
import { IUser } from '@/features/user/store/user.model';

export enum P2PActionTypes {
  P2P_TRANSFER = 'P2P.P2P_TRANSFER',
  P2P_TRANSFER_SUCCESS = 'P2P.P2P_TRANSFER_SUCCESS',
  P2P_TRANSFER_FAIL = 'P2P.P2P_TRANSFER_FAIL',

  P2P_SEARCH_WALLETS = 'P2P.P2P_SEARCH_WALLETS',
  P2P_SEARCH_WALLETS_SUCCESS = 'P2P.P2P_SEARCH_WALLETS_SUCCESS',
  P2P_SEARCH_WALLETS_FAIL = 'P2P.P2P_SEARCH_WALLETS_FAIL',

  P2P_UNSET_WALLETS = 'P2P.P2P_UNSET_WALLETS',
}

export interface IP2PTransferAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_TRANSFER;
}

export interface IP2PTransferSuccessAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_TRANSFER_SUCCESS;
  transfer: ITransferP2P;
}

export interface IP2PTransferFailAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_TRANSFER_FAIL;
  error: TAppError;
}

export interface IP2PSearchBeneficiaryWalletsAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_SEARCH_WALLETS;
}

export interface IP2PSearchBeneficiaryWalletsSuccessAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_SEARCH_WALLETS_SUCCESS;
  wallets: IWallet[];
}

export interface IP2PSearchBeneficiaryWalletsFailAction extends IBaseAction {
  type: typeof P2PActionTypes.P2P_SEARCH_WALLETS_FAIL;
  error: TAppError;
}

export interface IP2PUnsetWallets extends IBaseAction {
  type: typeof P2PActionTypes.P2P_UNSET_WALLETS;
}

export type TP2PAction =
  | IP2PTransferAction
  | IP2PTransferSuccessAction
  | IP2PTransferFailAction
  | IP2PSearchBeneficiaryWalletsAction
  | IP2PSearchBeneficiaryWalletsSuccessAction
  | IP2PSearchBeneficiaryWalletsFailAction
  | IP2PUnsetWallets;

export interface IP2PState extends IBaseState {
  transfers: Array<ITransferP2P>;
  wallets?: IState<IWallet[]>;
  beneficiariesP2P?: IState<ICursorElements<IUser>>;
  currentFilters: ISearchWalletP2P;
}
